export var injectCssPropertiesIntoRootElementMutatorFactory = function (cssProps, _experiments) { return function (el) {
    Object.keys(cssProps).forEach(function (key) {
        if (!el.css(key)) {
            el.css(key, cssProps[key]);
        }
    });
}; };
//# sourceMappingURL=inject-css-properties-into-root-element.js.map